import { makeObservable, observable, action, reaction } from 'mobx';
import axios, { storeGet } from "../utils/axios";

class translateStore {
  editor_mode=false;
  translate={ fetching: false,inited: false,data:{},};
  lang="ru";
  par=null;

  get t() {
    return this.translate.data;
  }
  constructor(par) {
    this.par=par;
    makeObservable(this, {
      editor_mode: observable,
      translate: observable,
      lang: observable,
    });

    reaction(()=>{
      return this.lang;
    },(lang)=>{
      this.fetchTranslate();
    });
  }
  fetchTranslate() {
    storeGet(`/api/translate?forcelang=${this.lang}`, this.translate);
  }

}

/*
decorate(switchStore,{
  editor_mode:observable,
});
*/

export default translateStore;
